import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { RestRoutes } from '../_config/rest-routes.config';
import { ReasonsDTO, SubReasonsDTO } from '../_models/ReasonsDTO.model';



@Injectable({
  providedIn: 'root'
})
export class DisputeReasons {

  httpOptions = {
    headers: new HttpHeaders(
      {
        'Content-Disposition': 'multipart/form-data'
      }
    )
  };

  constructor(private http: HttpClient) { }

  GetReasons(parameters:any): Observable< SubReasonsDTO[]> {
    const url: string = `${environment.urlWS}${RestRoutes.DISPUTE_SUBREASONS}`;
    //console.log(url)
    return this.http.post<SubReasonsDTO[]>(url, parameters, this.httpOptions);
  }
}
